import { HttpErrorResponse } from '@angular/common/http';

export abstract class ErrorHandler {
    abstract getErrorMsg(error: unknown): string;
    abstract getHttpErrorResponse(httpError: HttpErrorResponse): string;
}
